<mat-sidenav-container class="mainWrapper" autosize autoFocus [ngClass]="{
  'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top' &&  !resView,
  'sidebarNav-mini-no-hover': sidebarMiniHoverDisabled,
  'sidebarNav-horizontal': options.horizontal,
  cardBorder: options.cardBorder,
  
}" [dir]="options.dir!">
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->
  @if (!options.horizontal && !resView) {
  <mat-sidenav (mouseenter)="onSidebarMouseEnter()" (mouseleave)="onSidebarMouseLeave()" #leftsidenav
    [mode]="isOver ? 'over' : 'side'"
    [opened]="isVerticalSidenavOpened"
    (openedChange)="onSidenavOpenedChange($event)"
    (closedStart)="onSidenavClosedStart()"
    class="sidebarNav">
    <div class="flex-layout">
      <app-sidebar
        (toggleMobileNav)="sidenav.toggle()"
        (toggleCollapsed)="toggleCollapsed()"
        [showToggle]="isOver"
        [showSidenavDockToggle]="!isOver"></app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(item of unblockedNavItems; track getNavItemTrackId(item)) {
          <app-nav-item [item]="item" (notify)="closeSidenavIfOverlay()">
          </app-nav-item>
          }
          @if(!options.sidenavCollapsed && hasBlockedNavMenuItems) {
          <div class="nav-caption blocked-nav-caption">
            {{ 'side_menu.locked_until_store_linked' | translate }}
          </div>
          @for(item of blockedNavItems; track getNavItemTrackId(item)) {
          <app-nav-item [item]="item" (notify)="closeSidenavIfOverlay()">
          </app-nav-item>
          }
          }
        </mat-nav-list>
      </ng-scrollbar>

      <!-- contactSuportButton -->
      @if (!isDelegatedUser) { <app-usage-overview-sidenav /> }
      <div class="profile-bar p-10 border-top" style="margin-top: auto;">
        <button style="width: 100%;" mat-button color="primary" (click)="onSuport()">
          {{ 'header.contact_support' | translate }}
          <mat-icon>mail</mat-icon>
        </button>
      </div>


      <!-- <div class="p-24 m-t-auto profile-bar">
        <div class="bg-light-secondary rounded p-16">
          <div class="d-flex flex-column align-items-center text-center" style="margin-bottom: 16px;">
            <span class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
              style="width: 56px; height: 56px; font-size: 1.2rem; font-weight: 600; margin-bottom: 12px;">
              {{ user.initials }}
            </span>
            <h4 class="f-w-600 m-0"
              style="font-size: 1rem; line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;">
              {{ user.name }}
            </h4>
            <span class="f-s-12 text-muted d-flex align-items-center justify-content-center"
              style="margin-top: 8px; gap: 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;">
              <i-tabler name="mail" class="icon-14 d-flex"></i-tabler>
              <span style="overflow: hidden; text-overflow: ellipsis;">{{ user.email }}</span>
            </span>
          </div>
          <button mat-stroked-button color="primary" class="w-100" (click)="logOut()"
            [matTooltip]="'header.logout_tooltip' | translate">
            <span class="d-flex justify-content-center align-items-center">
              <i-tabler name="power" class="icon-16 m-r-8"></i-tabler>
              {{ 'header.Logout' | translate }}
            </span>
          </button>
        </div>
      </div> -->
    </div>
  </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- horizontal Sidebar -->
  <!-- ============================================================== -->
  @if (resView) {
  <mat-sidenav #leftsidenav [mode]="'over'" [opened]="options.sidenavOpened"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    <app-sidebar (toggleMobileNav)="sidenav.toggle()"></app-sidebar>
    <ng-scrollbar class="position-relative" style="height: 100%">
      <mat-nav-list class="sidebar-list">
        @for(item of unblockedNavItems; track getNavItemTrackId(item)) {
        <app-nav-item [item]="item" (notify)="closeSidenavIfOverlay()"> </app-nav-item>
        }
        @if(!options.sidenavCollapsed && hasBlockedNavMenuItems) {
        <div class="nav-caption blocked-nav-caption ">
          {{ 'side_menu.locked_until_store_linked' | translate }}
        </div>
        @for(item of blockedNavItems; track getNavItemTrackId(item)) {
        <app-nav-item [item]="item" (notify)="closeSidenavIfOverlay()"> </app-nav-item>
        }
        }
      </mat-nav-list>
    </ng-scrollbar>
    <!-- <div class="p-24 m-t-auto profile-bar">
      <div class="bg-light-secondary rounded p-16">
        <div class="d-flex flex-column align-items-center text-center" style="margin-bottom: 16px;">
          <span class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
            style="width: 56px; height: 56px; font-size: 1.2rem; font-weight: 600; margin-bottom: 12px;">
            {{ user.initials }}
          </span>
          <h4 class="f-w-600 m-0"
            style="font-size: 1rem; line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;">
            {{ user.name }}
          </h4>
          <span class="f-s-12 text-muted d-flex align-items-center justify-content-center"
            style="margin-top: 8px; gap: 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;">
            <i-tabler name="mail" class="icon-14 d-flex"></i-tabler>
            <span style="overflow: hidden; text-overflow: ellipsis;">{{ user.email }}</span>
          </span>
        </div>
        <button mat-stroked-button color="primary" class="w-100" (click)="logOut()"
          [matTooltip]="'header.logout_tooltip' | translate">
          <span class="d-flex justify-content-center align-items-center">
            <i-tabler name="power" class="icon-16 m-r-8"></i-tabler>
            {{ 'header.Logout' | translate }}
          </span>
        </button>
      </div>
    </div> -->
    <div>
      <!-- contactSuportButton -->
      @if (!isDelegatedUser) { <app-usage-overview-sidenav /> }
      <div class="profile-bar p-10 border-top" style="margin-top: auto;">
        <button style="width: 100%;" mat-button color="primary" (click)="onSuport()">
          {{ 'header.contact_support' | translate }}
          <mat-icon>mail</mat-icon>
        </button>
      </div>
    </div>
  </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper" #content>
    <!-- ============================================================== -->
    <!-- VerticalHeader -->
    <!-- ============================================================== -->
    @if (!options.horizontal) {
    <app-header [showToggle]="!isOver"
      (toggleCollapsed)="toggleCollapsed()" (toggleMobileNav)="sidenav.toggle()"
      (optionsChange)="receiveOptions($event)"></app-header>
    } @else {
    <!-- horizontal header -->
    <app-horizontal-header (toggleMobileNav)="sidenav.toggle()"
      (optionsChange)="receiveOptions($event)"></app-horizontal-header>
    } @if(options.horizontal) {
    <app-horizontal-sidebar></app-horizontal-sidebar>
    }

    <main class="pageWrapper" [ngClass]="{
        maxWidth: options.boxed,
        'pageWrapper--dashboard': isDashboardRoute,
        'pageWrapper--full-width-list': isFullWidthListRoute
      }">
      <!-- <app-breadcrumb></app-breadcrumb> -->
      <!-- ============================================================== -->
      <!-- Outlet -->
      <!-- ============================================================== -->
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>